export const ORDERS_SECTIONS = [
  '',
  'new',
];

export const DEFAULT_ORDERS_SECTION = '';
